<template>
  <div style="background-color: #fff; padding: 20px 10px">
    <!-- 积分头 -->
    <div>
      <div class="view_flex" style="justify-content: space-between">
        <div
          class="view_flex"
          style="width: 255px; justify-content: space-between"
        >
          <div class="view_flex">
            <img :src="pointDetail.icon" style="width: 40px" alt="" />
            <p style="color: #c22c25; margin-left: 10px">
              {{ pointDetail.levelName }}
            </p>
          </div>
          <div class="view_flex">
            <p style="color: #ff9900; margin: 0 10px">
              {{ pointDetail.point }}
            </p>
            <p>积分</p>
          </div>
        </div>
        <!-- <p>积分须知</p> -->
      </div>

      <div class="view_flex" style="height: 50px">
        <div style="width: 255px">
          <el-progress
            :percentage="progress"
            status="warning"
            :show-text="false"
          ></el-progress>
        </div>
        <p style="margin-left: 20px; font-size: 14px" v-show="pointNoneFull">
          距离 {{ pointDetail.nextLevelName }} 还需要{{
            pointDetail.nextPoint
          }}积分
        </p>
      </div>
    </div>

    <!-- 积分权益 -->
    <!-- <div class="view_border">
      <p style="color: #c22c25;margin: 10px 0;font-size: 14px;text-align: center;">积分权益</p>
      <div class="pointEquity">
        <div
          v-for="item in 6"
          :key="item"
          :class="[
            item % 2 == 1 ? 'back_yellow' : 'back_piple',
            'pointEquity_list',
          ]"
        >
          <div>
            <p style="font-size: 16px;">协会活动优先</p>
            <p style="font-size: 14px;margin-top: 10px;">一句话功能介绍</p>
          </div>
          <img src="" alt="" />
        </div>
      </div>
    </div> -->
    <!-- 积分获得 -->
    <div class="view_border">
      <p style="color: #c22c25; margin: 10px 0; font-size: 14px">积分获得</p>
      <div
        class="view_flex getPoint"
        v-for="(item, index) in getPointList"
        :key="index"
      >
        <p>{{ item.pointName }}</p>
        <p style="min-width: 300px">{{ item.pointDesc }}</p>
      </div>
    </div>
    <!-- 积分明细 -->
    <div style="padding: 10px 20px;">
      <div class="view_flex" style="justify-content: space-between">
        <div
          class="view_flex"
          style="justify-content: space-between; width: 300px"
        >
          <p
            :class="[selectIndex === 0 ? 'setActive' : 'setNull']"
            @click="changeDetail(0)"
          >
            积分明细
          </p>
          <span class="setNull">|</span>
          <p
            :class="[selectIndex === 1 ? 'setActive' : 'setNull']"
            @click="changeDetail(1)"
          >
            收入积分
          </p>
          <span class="setNull">|</span>
          <p
            :class="[selectIndex === -1 ? 'setActive' : 'setNull']"
            @click="changeDetail(-1)"
          >
            积分使用
          </p>
        </div>
        <!-- <button>积分补登</button> -->
      </div>
      <div>
        <div
          v-for="(item, index) in detailList"
          class="view_flex setList"
          :key="index"
        >
          <p style="width: 200px">{{ item.pointName }}</p>
          <p style="width: 200px">{{ item.createTime }}</p>
          <p style="width: 200px">
            {{ item.pointType == "1" ? "+" : "-" }} {{ item.point }}
          </p>
        </div>
        <div style="display: flex;justify-content: center;margin: 20px 0;">
          <el-pagination
            background
            layout="prev, pager, next"
            :hide-on-single-page="true"
            :total="totoal"
            :current-page="pageNo"
            @size-change="sizeChange"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCurrentPoint,
  getPointInfo,
  getPointDetail,
} from "@/api/moudles/home.js";
export default {
  data() {
    return {
      pointDetail: {},
      progress: 0,
      pointNoneFull: true,
      getPointList: [],
      selectIndex: 0,
      pageNo: 1,
      pageSize: 10,
      detailList: [],
      totoal: 0,
    };
  },
  created() {
    this.getLocalCurrentPoint();
    this.getLocalPoint();
    this.getLocalDetail();
  },
  methods: {
    sizeChange(e) {
      console.log("sizechange", e);
    },
    currentChange(e) {
      console.log("currentChange", e);
      this.pageNo = e;
      this.getLocalDetail();
    },
    changeDetail(index) {
      this.selectIndex = index;
      this.pageNo = 1;
      this.getLocalDetail();
    },
    // 积分详情
    async getLocalCurrentPoint() {
      await getCurrentPoint({
        success: (res) => {
          if (res.data) {
            this.pointDetail = res.data;
            const { point, nextPoint } = res.data;
            this.progress =
              parseFloat(point / (point + nextPoint)).toFixed(2) * 100;
            this.pointNoneFull = point < point + nextPoint;
          }
        },
      });
    },
    // 积分获得
    async getLocalPoint() {
      await getPointInfo({
        success: (res) => {
          if (res.data && res.data.length) {
            this.getPointList = res.data;
          }
        },
      });
    },
    // 获取积分 分类详情
    async getLocalDetail() {
      await getPointDetail({
        data: {
          type: this.selectIndex,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        },
        success: (res) => {
          console.log("积分获取详情", res);
          if (res.data && res.data.list.length) {
            this.detailList = res.data.list;
            this.totoal = parseInt(res.data.total);
          } else {
            this.detailList = [];
            this.totoal = 0;
          }
        },
      });
    },
  },
};
</script>
<style scoped>
::v-deep(.el-progress-bar__outer) {
  height: 10px !important;
}
.setList {
  margin: 10px 0;
  font-size: 14px;
  width: 800px;
  justify-content: space-between;
}
.setActive {
  color: #c22c25;
  cursor: pointer;
}
.setNull {
  color: #d7d7d7;
  cursor: pointer;
}
.getPoint {
  width: 500px;
  margin: 10px 0;
  font-size: 14px;
  justify-content: space-between;
}
.back_yellow {
  background-color: #ffe1b3;
  color: #ff9900;
}
.back_piple {
  background-color: #cfe1ff;
  color: #5e9afe;
}
.view_flex {
  display: flex;
  align-items: center;
}
.view_border {
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 10px 20px;
  margin-bottom: 20px;
}
.pointEquity {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
}
.pointEquity_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  min-height: 74px;
  padding: 10px 20px;
}
</style>
